import React, { Component } from 'react'; //import React Component
import 'whatwg-fetch'; // import fetch 
// react bootstrap imports
import DropdownButton from 'react-bootstrap/DropdownButton'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Dropdown from 'react-bootstrap/Dropdown'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

// Creates individual villager card
export class VillagerCard extends Component {
    // converts birthday season from number representation to string representation
    findBirthdaySeason(season) {
        if (season === 1) {
            return "Winter"
        } else if (season === 2) {
            return "Spring"
        } else if (season === 3) {
            return "Summer"
        } else {
            return "Fall"
        }
    }

    render() {
        let villager = this.props.villager;
        return(
            <Col className="card-col" md={6} xl={3}>
                <Card className="h-100 shadow-sm villager-card">
                    <div className="villager-background">
                        <Card.Img className="villager-img" variant="top" alt={villager.name} src={villager.img}/>
                    </div>
                    <Card.Body>
                        <Card.Title className="card-title">{villager.name}</Card.Title>
                        <Card.Text>
                            <em>"{villager.quotes}"</em>
                        </Card.Text>
                    </Card.Body>
                    <div className="villager-back-card">
                        <Card.Body>
                            <Card.Text>
                                <strong>Species: </strong>{villager.species}
                                <br/>
                                <strong>Birthday Season: </strong>{this.findBirthdaySeason(villager.birthday)}
                                <br/>
                                <strong>Personality: </strong>{villager.personality}
                            </Card.Text>
                        </Card.Body>
                    </div>
                </Card>
            </Col>
        );
      }

} 

export class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            villagers: this.props.villagers, // stores villagers
            season: null, // season filter
            personality: null, // personality filter
            showAlert: false // shows alert box when user uses filters function
        };
    }

    // converts birthday season from number representation to string representation
    findBirthdaySeason(season) {
        if (season === 1) {
            return "Winter"
        } else if (season === 2) {
            return "Spring"
        } else if (season === 3) {
            return "Summer"
        } else {
            return "Fall"
        }
    }

    // return filters user chose
    findFilters() {
        let season = this.findBirthdaySeason(Number(this.state.season));
        if (this.state.season !== null && this.state.personality !== null) {
            return (season + " Birthday and " + this.state.personality + " Personality");
        } else if (this.state.season !== null) {
            return season + " Birthday";
        } else if (this.state.personality !== null) {
            return this.state.personality + " Personality";
        }
    }

    // when user clicks on a birthday season filter 
    handleSelectSeason = (eventKey, event) => {
        console.log("You clicked", this.findBirthdaySeason(Number(eventKey)));
        let value = Number(eventKey); // converts from string to integer
        this.setState({season: value}); // rerenders content to display villagers that have the birthday season user selected
        this.setState({showAlert: true}); // alerts pops up
    }
    
    // when user clicks on a personality season filter 
    handleSelectPersonality = (eventKey, event) => {
        console.log("You clicked", eventKey);
        let value = eventKey;
        this.setState({personality: value}); 
        this.setState({showAlert: true}); // alerts pops up
    }
     
    // when user clicks on the reset button and clear filter
    handleClickReset = (event) => {
        event.preventDefault();
        console.log("clears filters");
        this.setState({personality: null}); 
        this.setState({season: null}); // rerenders content to display all villagers
        this.setState({showAlert: false}); // alert goes away
    }
    
    render() {
        // store villagers in variable
        let filteredVillagers = this.props.villagers;

        // filter by birthday season
        if (this.state.season !== null) { 
            filteredVillagers = filteredVillagers.filter((villager) => {
                return(villager.birthday === this.state.season);
            })
        }

        // filter by personality
        if (this.state.personality !== null) {
            filteredVillagers = filteredVillagers.filter((villager) => {
                return(villager.personality === this.state.personality);
            })
        }

        // create/store villagers cards
        let villagerRows = filteredVillagers.map((villager) => {
            return <VillagerCard villager={villager} key={villager.name}/>
        });

        return (
            <div className="directory-page">
                <Jumbotron id="directory-banner">
                    <Container>
                        <Row>
                            <h1 id="directory-title">Villager Directory</h1>
                        </Row>
                        <Row>
                            <h3 id="directory-sub-title">Learn more about the villagers of Animal Crossing!</h3>
                        </Row>

                        <Row>
                            <DropdownButton className="dropdown" id="dropdown-basic-button" variant="Info" title="Birthday Season">
                                <Dropdown.Item eventKey={1} onSelect={this.handleSelectSeason}>Winter</Dropdown.Item>
                                <Dropdown.Item eventKey={2} onSelect={this.handleSelectSeason}>Spring</Dropdown.Item>
                                <Dropdown.Item eventKey={3} onSelect={this.handleSelectSeason}>Summer</Dropdown.Item>
                                <Dropdown.Item eventKey={4} onSelect={this.handleSelectSeason}>Fall</Dropdown.Item>
                            </DropdownButton>

                            <DropdownButton className="dropdown" id="dropdown-basic-button" variant="Info" title="Personalities">
                                <Dropdown.Item eventKey="Normal" onSelect={this.handleSelectPersonality}>Normal</Dropdown.Item>
                                <Dropdown.Item eventKey="Lazy" onSelect={this.handleSelectPersonality}>Lazy</Dropdown.Item>
                                <Dropdown.Item eventKey="Jock" onSelect={this.handleSelectPersonality}>Jock</Dropdown.Item>
                                <Dropdown.Item eventKey="Peppy" onSelect={this.handleSelectPersonality}>Peppy</Dropdown.Item>
                                <Dropdown.Item eventKey="Sisterly" onSelect={this.handleSelectPersonality}>Sisterly</Dropdown.Item>
                                <Dropdown.Item eventKey="Cranky" onSelect={this.handleSelectPersonality}>Cranky</Dropdown.Item>
                                <Dropdown.Item eventKey="Snooty" onSelect={this.handleSelectPersonality}>Snooty</Dropdown.Item>
                                <Dropdown.Item eventKey="Smug" onSelect={this.handleSelectPersonality}>Smug</Dropdown.Item>
                            </DropdownButton>
                            <Button className="dropdown" variant="light" onClick={this.handleClickReset}>Reset</Button>
                        </Row>
                    </Container>
                </Jumbotron>

                <main>
                    <Container>
                        <Row>
                            {this.state.showAlert &&
                                <Alert variant="success" onClose={() => this.setState({showAlert: false})} dismissible>
                                    <p>Showing villagers with a <strong>{this.findFilters()}</strong>:</p>
                                </Alert>
                            }
                        </Row>
                        <Row>
                            {villagerRows}
                        </Row>
                    </Container>
                </main>
            </div>
        );
    }
  }



export class Cards extends Component {

    constructor(props) {
        super(props); //pass up to parent
        this.state = {
            villagers: [] // stores villagers info 
        };
      }

    componentDidMount() {
        fetch('./data/villagers.json') //local file
          .then((res) => res.json())
          .then((data) => {
            let listVillagers = data.map((villager) => {
              return {
                name: villager.villager,
                personality: villager.personality,
                birthday: villager.birthday,
                milk: villager.milk,
                quotes: villager.quotes,
                numbers: villager.numbers,
                species: villager.species,
                img: villager.img
              }
            })
            this.setState({villagers:listVillagers})  
          })
      }


    render() {
        return (
            <div className="container">
                <Body villagers={this.state.villagers}/>
            </div>
        );
    }
  }

  export default Cards;